import React from "react";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import Projects from "./components/Projects/Projects";
import { projectList } from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import { skillsList } from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import { experiences } from "./components/Experience/Experience";
import Education from "./components/Education/Education";
import Contact from "./components/Contact/Contact";
import BackToTopButton from "./components/BackToTopButton/BackToTopButton";
import ChatBot from "./components/ChatBot/ChatBot"
import ScrollProgress from "./components/ScrollProgress/ScrollProgress";
import Footer from "./components/Footer/Footer";
import "./App.css";

const App = () => {
  const portfolioData = {
    intro: "Hi, I'm Eddie — a Software Development Engineer at Capital Group. I own and maintain production backend services across full-stack apps, streaming pipelines, and cloud infrastructure. Toolkit: C#, .NET Core, TypeScript, Python, FastAPI, Kafka, Terraform, AWS. Based in Irvine, CA.",
    projects: projectList.map((p) => ({
      name: p.title,
      desc: p.description,
      tech: p.tags,
    })),
    experience: experiences.map((e) => ({
      date: e.date,
      role: e.role,
      company: e.company,
      description: e.description,
    })),
    skills: skillsList.map((s) => ({ skillName: s.name })),
    education: {
      School: "California State University, Fullerton",
      Degree: "B.S. Computer Science (May 2024)",
      Honors: "Dean's List 2023 and 2024; Engineering Social Justice: A Design Challenge — Top-10 Finalist",
      Coursework: "Data Structures and Algorithms, Algorithm Engineering, Operating System Concepts, Computer Communications, Software Engineering, Object-Oriented Programming, File Structure & Database, Web Back-End Engineering, Web Front-End Engineering, Artificial Intelligence, Compilers and Languages, Cybersecurity Foundations and Practices, Computer Organization & Assembly Language, Principles of Computer Graphics, Computational Bioinformatics, Python Programming, Computer Science Principles, Intro to Programming",
      Certifications: "AWS Certified Cloud Practitioner",
    },
  };

  return (
    <div className="App">
      <ScrollProgress />
      <Navbar />
      <Header />
      <Education />
      <Experience />
      <Projects />
      <Skills />
      <Contact />
      <Footer />
      <ChatBot portfolioData={portfolioData} />
      <BackToTopButton />
    </div>
  );
};

export default App;
